
import React from 'react';

interface ComplianceHeaderProps {
  title: string;
  description: string;
}

const ComplianceHeader: React.FC<ComplianceHeaderProps> = ({ title, description }) => {
  return (
    <div className="text-center mb-8">
      <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
        {title}
      </h1>
      <p className="text-gray-600 max-w-2xl mx-auto">
        {description}
      </p>
    </div>
  );
};

export default ComplianceHeader;
